import { Col, Row } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';

import { EditNumber } from 'components/forms/EditNumber';
import { EditSelect } from 'components/forms/EditSelect';
import { EditSchedulingWindowReference } from 'edit/reference/EditSchedulingWindowReference';

import type { EditableSchedule } from './EditableSchedule';
import type { ScheduleRuleFieldOptions } from './ScheduleRulePeriodFields';

interface Props {
  readonly schedule: EditableSchedule;
  readonly unit: 'period' | 'month';
  readonly opts: ScheduleRuleFieldOptions;
}

/**
 * Advanced opening-rule fields (nth-of-unit and cross-window constraints).
 */
export const ScheduleRuleAdvancedFields = observer<Props>(({ schedule, unit, opts }) => (
  <>
    <Row className="mb-3 mt-2">
      <Col md={6}>
        <EditSelect<number | null>
          label={`From nth of ${unit}`}
          value={schedule.nthOfMonthFrom}
          onChange={(v) => (schedule.nthOfMonthFrom = v)}
          options={opts.nth}
        />
      </Col>
      <Col md={6}>
        <EditSelect<number | null>
          label={`Until nth of ${unit}`}
          value={schedule.nthOfMonthUntil}
          onChange={(v) => (schedule.nthOfMonthUntil = v)}
          options={opts.nth}
        />
      </Col>
    </Row>

    <Row className="mb-3">
      <Col md={6}>
        <EditSchedulingWindowReference
          label={`Count nth-of-${unit} within`}
          value={schedule.nthOfMonthFromInWindow}
          onChange={(v) => (schedule.nthOfMonthFromInWindow = v)}
        />
      </Col>
      <Col md={6}>
        <EditSchedulingWindowReference
          label={`Count nth-of-${unit} until within`}
          value={schedule.nthOfMonthUntilInWindow}
          onChange={(v) => (schedule.nthOfMonthUntilInWindow = v)}
        />
      </Col>
    </Row>

    <Row className="mb-3">
      <Col md={6}>
        <EditSchedulingWindowReference label="Shift if closed in" value={schedule.shiftIfClosedWindow} onChange={(v) => (schedule.shiftIfClosedWindow = v)} />
      </Col>
      <Col md={6}>
        <EditNumber label="Shift by open days" value={schedule.shiftOpenDays} onChange={(v) => (schedule.shiftOpenDays = v)} />
      </Col>
    </Row>

    <Row>
      <Col md={6}>
        <EditSchedulingWindowReference label="Only while open in" value={schedule.openDuringWindow} onChange={(v) => (schedule.openDuringWindow = v)} />
      </Col>
      <Col md={6}>
        <EditSchedulingWindowReference label="Not while open in" value={schedule.closedDuringWindow} onChange={(v) => (schedule.closedDuringWindow = v)} />
      </Col>
    </Row>
  </>
));
